import { Button, ListItem } from '@material-ui/core';
import React from 'react';
import { WalletIcon } from './WalletIcon';
export const WalletListItem = ({ handleClick, wallet }) => {
    return (React.createElement(ListItem, null,
        React.createElement(Button, { onClick: handleClick, endIcon: React.createElement(WalletIcon, { wallet: wallet }) }, wallet.name)));
};
//# sourceMappingURL=WalletListItem.js.map